/* eslint-disable */
import React, { useEffect } from 'react'
import { useState } from 'react'
import { Link, useLocation, useParams } from 'react-router-dom';
import { api_url, stripe_key } from '../../Constants/web_services';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { selectSignedIn, selectUserData } from '../../Redux/UserSlice';
import axios from 'axios';
import '../../Assets/css/custom.css'
import Swal from 'sweetalert2';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import Thanks from './UserPanelParts/Thanks.jsx';
import No_Order from './UserPanelParts/No_Order.jsx';
import Loading from '../SearchList/Loading';
import AddTime from './UserPanelParts/AddTime';
import CancelOrder from './UserPanelParts/CancelOrder.jsx';
import OrderCancel from './UserPanelParts/OrderCancel.jsx';
import Payment from './UserPanelParts/Payment.jsx';

const OrderDetailScreen = () => {
  const isSignedIn = useSelector(selectSignedIn);
  const userData = useSelector(selectUserData);
  const [tabs, setTabs] = useState("details");
  const [clientSecret, setClientSecret] = useState('');
  const { id: orderId } = useParams();
  const [order, setOrder] = useState([]);

  const location = useLocation();
  const isOrderDetailsPage = location.pathname.includes("/user-profile/:id/order-details/:id");



  useEffect(() => {
    if (orderId) {
      const fetchOrderDetail = async () => {
        try {
          const token = localStorage.getItem('token'); // Retrieve the token from local storage or another storage method

          const response = await fetch(`${api_url}/api/user-profile/order-detail/${orderId}`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}` // Include the token in the Authorization header
            }
          });

          if (!response.ok) {
            throw new Error("Network response was not ok");
          }

          const orderdetail = await response.json();
          setOrder(orderdetail?.data);
        } catch (error) {
          console.error("Error fetching order data:", error);
        }
      };

      fetchOrderDetail();
    }
  }, [api_url, orderId]);


  const handleTabs = (val) => {
    if (val) {
      setTabs(val)
    }
  }

  const getBackgroundColor = (orderStatus) => {
    switch (orderStatus) {
      case "Order Placed": return "bg-warning";

      case "Payment Confirmed": return "bg-secondary";

      case "Project Started": return "bg-success";

      case "Mid Progress": return "bg-primary";

      case "Approval Finalize": return "bg-info";

      case "Review": return "bg-danger";

      case "Completed": return "bg-dark";

      case "Order Cancel": return "bg-danger";
      // Delivered

      default: return "bg-light text-black";
    }
  };
  //payment intent
  useEffect(() => {

    const fetchData = () => {

      if (order && order.id && order.order_status === 'Order Placed' && userData) {
        const payload = {
          user_id: userData?.id,
          order_id: order?.id,
          amount: order?.payment,
          company_id: order?.company?.id
        };

        fetch(api_url + "/api/payment-intent", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload)
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error("Network response was not ok");
            }
            return response.json();
          })
          .then((data) => {
            setClientSecret(data?.data?.client_secret);
          })
          .catch((error) => {
            console.error("Error fetching order data:", error);
          })
      }
    };


    fetchData();
  }, [userData, order]);
  if (tabs === 'payment' && order?.order_status === 'Order Placed' && order?.is_accept === 2) {
    const stripePromise = loadStripe(stripe_key);
  }
  const options = {
    // passing the client secret obtained from the server
    clientSecret: clientSecret,

  };


  const requestUpdate = async (e, isAccepted) => {
    e.preventDefault();
    const token = localStorage.getItem('token');
    try {
      const response = await axios.post(api_url + `/api/changeStatusByUser/${order.id}`, {
        is_accept: isAccepted,
        changeStatusByUser: 0
      }, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
      });
      if (response.status !== 200) {
        throw new Error('Failed to update order status');
      }

      console.log('Order status updated successfully');
    } catch (error) {
      console.error('Error updating order status:', error.message);
    }
  };

  const calculateTimeLeft = () => {
    const difference = +new Date(order?.end_duration) - +new Date();
    let timeLeft = {};

    if (difference) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60)
      };
    }
    return timeLeft;
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearTimeout(timer);
  });


  const previousDate = moment().subtract(1, 'days').format('L');

  return (
    <>
      {isSignedIn ? (
        <>
          <div id="content">
            <div className="content-admin-main my-5">
              <div className="admin-top-area border-0 shadow-bx d-flex flex-wrap justify-content-center m-b30 align-items-center">
                <h2 >User Panel</h2>
              </div>
              <div className="aon-admin-heading">
                <h4 className='s-16 fw-700 text-022279'>Order Details</h4>
              </div>


              <div className="card aon-card border-0 shadow">
                <div className="card-body aon-card-body">
                  <div className="sf-bd-data-tb-head"></div>
                  <div className="sf-availability-times-tab m-b20">
                    <div className="sf-custom-tabs sf-custom-new ">
                      <div className="row justify-content-between">


                        <div className="col-md-6 d-flex justify-content-start" >
                          <p className="s-16 fw-700 text-022279  text-uppercase">
                            Order Id # &nbsp;&nbsp;
                          </p>
                          <span className="s-16 fw-700 text-022279">{order?.id}</span>
                        </div>
                        <div className=" col-md-6 d-flex justify-content-end" >
                          <Link to={`/user-profile/${userData?.id}/my-orders`}
                            className={`btn ${tabs === 'payment' ? 'btn-warning' : 'btn-blue-theme'}`}
                          >
                            Back to Order list
                          </Link>
                        </div>
                      </div>
                      <ul className="nav nav-tabs nav-table-cell">
                        <li onClick={() => handleTabs("details")}>
                          <Link
                            className={`${tabs === "details" ? "active" : ""
                              } cursor-pointer text-decoration-none`}
                          >
                            Description
                          </Link>
                        </li>
                        <li onClick={() => handleTabs("payment")}>
                          <Link
                            className={`${tabs === "payment" ? "active" : ""
                              } cursor-pointer text-decoration-none`}
                          >
                            Payment
                          </Link>
                        </li>
                      </ul>
                      {tabs === "details" && (
                        <>
                          <p className="s-16 fw-600 text-022279 mt-4">Description of your order</p>
                          <div className="row justify-content-around">

                            <dl className="col-md-4">
                              <dt>Company name</dt>
                              <dd>{order?.company?.name}</dd>

                              <dt>Order Status</dt>
                              <dd className={`badge badge-pill ${order?.order_status ? getBackgroundColor(order?.order_status) : "none-color"
                                }`}>{order?.order_status == null ? ("no status available") : (order?.order_status)}</dd>

                              <dt>Order Payment</dt>
                              <dd>{order?.payment}</dd>
                            </dl>
                            <dl className="col-md-4">
                              <dt>Last Update</dt>
                              <dd>{
                                moment(order?.latest_update, "YYYYMMDD").fromNow()}</dd>

                              <dt>Order Placed On</dt>
                              <dd>{moment(
                                order?.created_at
                              ).format(
                                "MMM Do YY, h:mm"
                              )
                              }</dd>
                              <dt>Completetion Date</dt>
                              <dd> {moment(
                                order?.end_duration
                              ).format(
                                "MMM Do YY, h:mm"
                              )}</dd>
                            </dl>
                            <dl className="col-md-4">
                              <dt>Update Request</dt>
                              {(order?.order_status !== 'Order Placed' && order?.order_status !== 'Payment Confirmed' && order?.order_status !== 'Order Cancel' && order?.change_status_by_user !== 0) ?
                                <>
                                  {order?.is_accept ? <>
                                    <dd> <button className="btn btn-danger btn-sm mt-1" onClick={(e) => requestUpdate(e, order?.is_accept)}>Accept</button></dd>
                                  </> : <dd><br /></dd>}
                                </>
                                : <>
                                  <dd>
                                    <button className="btn btn-sm mt-1 text-white fw-600" style={{ backgroundColor: '#0a933f' }}>Last Update Accepted</button>
                                  </dd>
                                </>}

                              <dt className='text-danger text-uppercase' style={{ fontSize: '34px' }}>Remaing Time</dt>

                              <div className={`radius-sm ${moment(previousDate)?.format('L') <= moment(order?.end_duration)?.format('L') ? 'bg-success' : 'bg-success'}`}>

                                <div className="text-white text-center fw-700">
                                  <h2 className='mb-3'>{timeLeft?.days} Days </h2>
                                  <div className="row justify-content-between mt-1">
                                    <div className="col-sm-4 ">
                                      <p className='m-0'>{timeLeft?.hours}</p>
                                      <p>Hours</p>
                                    </div>
                                    <div className="col-sm-4 ">
                                      <p className='m-0'> {timeLeft?.minutes}</p>
                                      <p>Minutes</p>
                                    </div>
                                    <div className="col-sm-4 ">
                                      <p className='m-0'>{timeLeft?.seconds}</p>
                                      <p>Seconds</p>
                                    </div>

                                  </div>
                                </div>
                              </div>
                              {/* <dt>Completetion Date</dt>
                              <dd> {moment(
                                order?.last_time_duration
                              ).format(
                                "MMM Do YY, h:mm"
                              )}</dd> */}
                            </dl>
                          </div>


                        </>
                      )}
                      {tabs === "payment" && (
                        <>
                          {Loading}
                          {clientSecret && order?.is_accept === 1 && !isOrderDetailsPage ? (
                            <Elements stripe={stripePromise} options={options}>
                              <Payment order={order} />
                            </Elements>
                          ) : (1 < order?.is_accept < 10 || order.order_status !== 'Order Placed' || order.order_status !== 'Order Cancel') ? (
                            <Thanks order={order} />
                          ) : (order?.is_accept === 0) || (order?.is_accept === null) ? (
                            <No_Order />

                          ) : (order.is_accept === 10 && order.order_status === 'Order Cancel') ?
                            <OrderCancel order={order} /> : null}
                        </>
                      )}
                    </div>
                  </div>

                </div>
              </div>
              {(order.is_accept === 10 || order.order_status === 'Order Cancel') ? (
                <div className="card aon-card border-0 shadow">
                  <div className="card-body aon-card-body">

                    <div className="sf-availability-times-tab m-b20">
                      <div className="sf-custom-tabs sf-custom-new ">


                        <OrderCancel />

                      </div>
                    </div>
                  </div>
                </div>
              ) : (order.is_accept === 1 && order.order_status === 'Order Placed') ? (
                <div className="card aon-card border-0 shadow">
                  <div className="card-body aon-card-body">

                    <div className="sf-availability-times-tab m-b20">
                      <div className="sf-custom-tabs sf-custom-new ">
                        {/*Tabs*/}
                        <ul className="nav nav-table-cell ">
                          <li>
                            <Link className="active text-decoration-none text-warning fw-700">
                              {(order?.order_status === 'Order Placed') ? <>Thanks </> : <>ORDERS ACTIONS AREA</>}
                            </Link>
                          </li>

                        </ul>
                        {/*Tabs Content*/}
                        <div className="tab-content">
                          {/*Upcoming*/}
                          <div id="Upcoming" className="tab-pane active">
                            <div className="sf-tabs-content">
                              <div className="sf-bs-data-table ">
                                <div className="row justify-content-between">
                                  {/* <dl className="col-md-5 justify-content-start">

                                    <AddTime order={order} />

                                  </dl> */}
                                  <dl className="col-md-5 justify-content-end">

                                    <CancelOrder order={order} />

                                  </dl>

                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (1 < order.is_accept < 10 && order.order_status !== 'Order Cancel' && order.order_status !== 'Order Placed') ? (
                <div className="card aon-card border-0 shadow">
                  <div className="card-body aon-card-body">

                    <div className="sf-availability-times-tab m-b20">
                      <div className="sf-custom-tabs sf-custom-new ">
                        {/*Tabs*/}
                        <ul className="nav nav-table-cell ">
                          <li>
                            <Link className="active text-decoration-none text-warning fw-700">
                              ORDERS ACTIONS AREA
                            </Link>
                          </li>

                        </ul>
                        {/*Tabs Content*/}
                        <div className="tab-content">
                          {/*Upcoming*/}
                          <div id="Upcoming" className="tab-pane active">
                            <div className="sf-tabs-content">
                              <div className="sf-bs-data-table ">
                                <div className="row justify-content-between">
                                  <dl className="col-md-5 justify-content-start">

                                    <AddTime order={order} />

                                  </dl>
                                  <dl className="col-md-5 justify-content-end">

                                    <CancelOrder order={order} />

                                  </dl>

                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>) : <></>}

            </div>

          </div >

        </>
      ) : null}
    </>
  )
}

export default OrderDetailScreen